"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendEvent;
exports.SEND_EVENT = void 0;
var SEND_EVENT = 'WEB_CHAT/SEND_EVENT';
exports.SEND_EVENT = SEND_EVENT;

function sendEvent(name, value) {
  return {
    type: SEND_EVENT,
    payload: {
      name: name,
      value: value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NlbmRFdmVudC5qcyJdLCJuYW1lcyI6WyJTRU5EX0VWRU5UIiwic2VuZEV2ZW50IiwibmFtZSIsInZhbHVlIiwidHlwZSIsInBheWxvYWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxVQUFVLEdBQUcscUJBQW5COzs7QUFFZSxTQUFTQyxTQUFULENBQW1CQyxJQUFuQixFQUF5QkMsS0FBekIsRUFBZ0M7QUFDN0MsU0FBTztBQUNMQyxJQUFBQSxJQUFJLEVBQUVKLFVBREQ7QUFFTEssSUFBQUEsT0FBTyxFQUFFO0FBQUVILE1BQUFBLElBQUksRUFBSkEsSUFBRjtBQUFRQyxNQUFBQSxLQUFLLEVBQUxBO0FBQVI7QUFGSixHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRU5EX0VWRU5UID0gJ1dFQl9DSEFUL1NFTkRfRVZFTlQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZW5kRXZlbnQobmFtZSwgdmFsdWUpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRU5EX0VWRU5ULFxuICAgIHBheWxvYWQ6IHsgbmFtZSwgdmFsdWUgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRU5EX0VWRU5UIH07XG4iXX0=